import CsvReader from '../../components/CsvReader/CsvReader.vue';
import ContentTypeMappingTable from '@/components/ContentTypeMappingTable/ContentTypeMappingTable.vue';
import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import endpointsList from '../../helpers/endpointsList';
import { ProjectType } from 'types';
import { Route } from '@/routes';

interface IContentTypeConfiguration {
  headers: any;
  contentTypeName: null | string;
}

export default defineComponent({
  name: 'ContentTypeConfiguration',
  components: { CsvReader, ContentTypeMappingTable },
  props: {
    contentTypeId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    mode: {
      type: String as () => ProjectType,
      required: true,
    },
    supplierId: {
      type: String,
      required: false,
    },
  },

  data(): IContentTypeConfiguration {
    return {
      headers: null,
      contentTypeName: null,
    };
  },

  mounted() {
    if (!this.contentTypeId) {
      this.$router.push({
        name: Route.PROJECTS_LIST,
      });
      return;
    }

    this.getContentTypeName();
  },

  methods: {
    getHeaders(value: any) {
      this.headers = value;
    },

    async getContentTypeName() {
      try {
        const response: AxiosResponse<string> = await axios.get(
          endpointsList.prodisApiIntegration.getContentTypeNameById(
            this.contentTypeId,
          ),
        );

        this.contentTypeName = response.data;
      } catch {
        //
      }
    },
  },
});
